import { isMobileApp } from 'utils';
import { exitApp } from 'console/entities/app';
const back_handlers = [];
// @ts-ignore
window.back_handlers = back_handlers;
// history.pushState and history.back must be called in different ticks
// of event loop. Strange things will happen in Chrome otherwise.
// So we are using task queue and execute actions from it in different
// main loop iterations.
const history_mutation_tasks = [];
let history_mutation_timer = null;
const enqueue_history_mutation_task = (task_fn, name) => {
    history_mutation_tasks.push([task_fn, name]);
    schedule_history_mutation_step();
};
const schedule_history_mutation_step = () => {
    if (history_mutation_timer)
        return;
    // setTimeout is used intentionally instead of setImmediate, see the comment above
    history_mutation_timer = setTimeout(history_mutation_step, 50);
};
const history_mutation_step = () => {
    history_mutation_timer = null;
    if (history_mutation_tasks.length === 0)
        return;
    const [task, name] = history_mutation_tasks.splice(0, 1)[0];
    task();
    if (history_mutation_tasks.length > 0)
        schedule_history_mutation_step();
};
export const push_back_item = (callback) => {
    back_handlers.push(callback);
    enqueue_history_mutation_task(() => window.history?.pushState(null, '', null), 'history.pushState');
};
let in_history_handler = false;
let expected_popstates = 0;
export const pop_back_item = (callback = null, should_go_back = true) => {
    let found;
    if (callback != null) {
        const index = back_handlers.indexOf(callback);
        if (index !== -1) {
            found = true;
            back_handlers.splice(index, 1);
        }
    }
    else {
        found = true;
        back_handlers.pop();
    }
    if (found &&
        !in_history_handler &&
        window.history?.pushState != null &&
        should_go_back) {
        expected_popstates++;
        // Intentionally using setTimeout here, not setImmediate. See the comment above.
        enqueue_history_mutation_task(() => window.history?.back(), 'history.back');
    }
};
export const on_back_button = () => back_handlers[back_handlers.length - 1]?.();
export const setup_back_button = () => {
    // @ts-ignore
    window.back_button = on_back_button;
    document.addEventListener('keydown', (ev) => {
        if (ev.key === 'Escape') {
            on_back_button();
        }
    });
    // Old versions of Chrome raise popstate on every load event
    // This affects, for example, Cordova under Android 4.4
    window.addEventListener('load', () => window.setImmediate(() => window.addEventListener('popstate', (ev) => {
        if (expected_popstates > 0) {
            expected_popstates--;
            return;
        }
        in_history_handler = true;
        try {
            on_back_button();
        }
        finally {
            in_history_handler = false;
        }
    })));
    if (isMobileApp()) {
        document.addEventListener('backbutton', on_back_button, false);
        push_back_item(exitApp);
    }
};
